// extracted by mini-css-extract-plugin
export default {"backdrop":"AddPaystubModal_backdrop__0Vmh7","modal":"AddPaystubModal_modal__VRQ3F"};